const state = {
  brokerDetails: {}
};
export default state;